import { Box } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

import { PAY_FILE_COMMENT_MAX_LENGTH } from "../constants"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { AerosTextField } from "@/components/UiKit/AerosTextField/AerosTextField"

interface PayFileInvoiceRemoveConfirmationDialogProps {
  isSubmitting: boolean
  onClose: () => void
  onConfirm: (comment: string) => void
}

export const PayFileInvoiceRemoveConfirmationDialog: FC<PayFileInvoiceRemoveConfirmationDialogProps> = ({
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [comment, setComment] = useState("")

  const handleConfirm = () => {
    onConfirm(comment.trim())
  }

  const content = (
    <Box className='flex flex-col gap-6 text-left'>
      <span className='text-center'>
        This will remove the payment from this pay file group. This action cannot be undone.
      </span>
      <AerosTextField
        label='Removal Comment'
        required
        value={comment}
        onChange={setComment}
        placeholder='Enter comment...'
        multiline
        minRows={3}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { maxLength: PAY_FILE_COMMENT_MAX_LENGTH } }}
        data-testid='pay-file.invoice-remove-confirmation-dialog.comment-field'
      />
    </Box>
  )

  return (
    <ConfirmationDialog
      title='Are you sure you want to remove this payment?'
      content={content}
      closeLabel='Go Back'
      confirmLabel='Remove Payment'
      isWarning
      confirmDisabled={!comment.trim() || isSubmitting}
      testIdPrefix='pay-file.invoice-remove-confirmation-dialog'
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
